import * as React from "react"
import { connect } from "react-redux"

import bem from "../../../../../bem"
import env from "../../../../../env"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { GlobalState } from "../../../../../store"

const b = bem.with("NewUI__userMenuUserInfo")

interface StateProps {
    fullName: string
    iconUrl: string
}

type Props = StateProps

export const UserInfo = ({ fullName, iconUrl }: Props): JSX.Element => (
    <ActionAnchor
        extraClasses={`${b()} is-inverted`}
        href={`${env.applicationPath}/account/profile`}
        tabIndex={-1}
    >
        <div className="tw-flex tw-justify-end tw-w-full tw-my-3">
            <div className={`${b("name")} h3 tw-font-medium tw-truncate`}>
                {fullName || "Unknown user"}
            </div>
            {!!iconUrl && (
                <div className={b("avatar") + "tw-ml-2"}>
                    <img alt="profile picture" src={iconUrl} />
                </div>
            )}
        </div>
    </ActionAnchor>
)

const mapStateToProps = (state: GlobalState): StateProps => ({
    fullName: state.userInfo.fullName,
    iconUrl: state.userInfo.iconUrl,
})

export default connect(mapStateToProps, {})(UserInfo)
